import React from 'react';
import { Button, Box, Divider, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

/**
 * 소셜 로그인 버튼들 컴포넌트
 * @param {object} props - 컴포넌트 props
 * @param {function} props.handleSocialLogin - 소셜 로그인 핸들러
 * @returns {JSX.Element} - 소셜 로그인 버튼들
 */
const SocialLoginButtons = ({ handleSocialLogin }) => {
  const { t } = useTranslation();

  return (
    <>
      <Box sx={{ mt: 3, mb: 2 }}>
        <Divider>
          <Typography variant="body2" sx={{ color: '#666' }}>
            {t('auth.or')}
          </Typography>
        </Divider>
      </Box>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        <Button
          fullWidth
          variant="outlined"
          onClick={() => handleSocialLogin('google')}
          sx={{
            borderColor: '#ccc',
            color: '#666',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: 2,
            '&:hover': {
              borderColor: '#999',
              bgcolor: 'rgba(0, 0, 0, 0.04)'
            }
          }}
        >
          <Box
            component="img"
            src="/google.svg"
            alt="Google 로고"
            sx={{
              width: 18,
              height: 18
            }}
          />
          {t('auth.continueWithGoogle')}
        </Button>
        <Button
          fullWidth
          variant="outlined"
          onClick={() => handleSocialLogin('kakao')}
          sx={{
            borderColor: '#FEE500',
            bgcolor: '#FEE500',
            color: '#000',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: 2,
            '&:hover': {
              borderColor: '#FEE500',
              bgcolor: '#FEE500',
              opacity: 0.9
            }
          }}
        >
          <Box
            component="img"
            src="/kakao.svg"
            alt="Kakao 로고"
            sx={{
              width: 18,
              height: 18
            }}
          />
          {t('auth.continueWithKakao')}
        </Button>
        {/* 네이버 로그인 - 검수 완료 후 활성화 예정
        <Button
          fullWidth
          variant="outlined"
          onClick={() => handleSocialLogin('naver')}
          sx={{
            borderColor: '#03C75A',
            bgcolor: '#03C75A',
            color: '#fff',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: 2,
            '&:hover': {
              borderColor: '#03C75A',
              bgcolor: '#03C75A',
              opacity: 0.9
            }
          }}
        >
          <Box
            component="img"
            src="/naver.png"
            alt="Naver 로고"
            sx={{
              width: 20,
              height: 20
            }}
          />
          {t('auth.continueWithNaver')}
        </Button>
        */}
      </Box>
    </>
  );
};

export default SocialLoginButtons; 